var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isPc || _vm.isTablet)?_c('div',{staticClass:"location_wrap"},[_c('div',{staticClass:"location"},[(_vm.root2)?[_c('span',[_vm._v(_vm._s(_vm.root2))]),_c('span',{staticClass:"svg_next"},[_vm._v(">")])]:_vm._e(),_c('div',{staticClass:"current"},[_c('router-link',{attrs:{"to":{
            name: 'category_books',
            params: {
              category: _vm.category.code,
              subCategory: _vm.category.code
            }
          }}},[_c('span',{staticClass:"txt"},[_vm._v(_vm._s(_vm.category.label))])])],1),(_vm.subcategory && _vm.subcategory.label)?[_c('span',{staticClass:"svg_next"},[_vm._v(">")]),_c('router-link',{attrs:{"to":{
            name: 'category_books',
            params: {
              category: _vm.category.code,
              subCategory: _vm.subcategory.code,
              subCategoryNm: _vm.subcategory.label
            }
          }}},[_c('span',{staticClass:"txt"},[_vm._v(_vm._s(_vm.subcategory.label))])])]:_vm._e()],2)]):_vm._e(),(_vm.isMobile)?_c('div',{staticClass:"location_wrap"},[_c('div',{staticClass:"current"},[_c('router-link',{attrs:{"to":{
          name: 'category_books',
          params: {
            category: _vm.category.code,
            subCategory: _vm.category.code
          }
        }}},[_c('span',{staticClass:"txt"},[_vm._v(_vm._s(_vm.category.label))])])],1),_c('div',{staticClass:"svg_next"},[_vm._v(">")]),(_vm.subcategory)?_c('div',{staticClass:"chapter"},[_c('router-link',{attrs:{"to":{
          name: 'category_books',
          params: {
            category: _vm.category.code,
            subCategory: _vm.subcategory.code
          }
        }}},[_c('span',{staticClass:"txt"},[_vm._v(_vm._s(_vm.subcategory.label))])])],1):_vm._e()]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }